import { SET_FILTER, CLEAR_FILTER, USER_FILTER, CONTENT_FILTER } from "../actions/filterActions";

const initialState = {
  userFilter: {
    searchValue: '',
    selectedGroups: [],
    selectedSiteNames: [],
    adminFilter: false,
    enabledFilter: false,
  },
  contentFilter: {
    searchValue: '',
    selectedGroups: [],
    selectedTypes: [],
    calendarDates: [],
    showExpired: false,
  },
}

function filterReducer(state = initialState, action) {
  const filterID = action && action.payload && action.payload.filterID ? action.payload.filterID : '';

  switch (action.type) {
  case SET_FILTER:
    if (filterID === USER_FILTER) {
      return {
        ...state,
        userFilter: action.payload.filter,
      }
    } else if (filterID === CONTENT_FILTER) {
      return {
        ...state,
        contentFilter: action.payload.filter,
      }
    } else {
      return state
    }
  case CLEAR_FILTER:
    if (filterID === USER_FILTER) {
      return {
        ...state,
        userFilter: initialState.userFilter
      }
    } else if (filterID === CONTENT_FILTER) {
      return {
        ...state,
        contentFilter: initialState.contentFilter
      }
    } else {
      return state
    }
  default:
    return state;
  }
}

export default filterReducer;